var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shan"},_vm._l((15),function(idx,index){return _c('div',{class:'shan'+idx},[_c('img',{attrs:{"src":_vm.getLuoItem(index)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }